import Toaster from '@meforma/vue-toaster';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { setupHttpInterceptors } from '@/app/providers';
import { vPermission } from '@/app/providers/directives';
import router from '@/app/providers/router';
import { initializePwaBootstrap, registerPwaServiceWorker } from '@/app/pwa';
import { isPlatformHost } from '@/shared/lib';
import { initializePwaInstallPrompt } from '@/shared/lib/pwa';

import App from './App.vue';
import { apolloClient } from './app/providers/apollo-provider';
import { initializeKkmJournalProvider } from './app/providers/kkm-journal-provider';

import './tailwind.css';
import '@/app/styles/index.css';

// Консоль платформы перекрашивается токенами `[data-surface='platform']` из variables.css.
if (isPlatformHost(window.location.origin)) {
  document.documentElement.dataset.surface = 'platform';
  document.title = 'Mors HQ';
}

initializeKkmJournalProvider();
initializePwaBootstrap({
  initializeInstallPrompt: initializePwaInstallPrompt,
  origin: window.location.origin,
  registerServiceWorker: registerPwaServiceWorker,
});

const app = createApp(App);
app.use(createPinia());

// Настраиваем HTTP интерсепторы после инициализации Pinia
setupHttpInterceptors();

// Регистрируем директиву v-permission
app.directive('permission', vPermission);

// Подключаем Apollo Client
app.provide(DefaultApolloClient, apolloClient);

app.use(Toaster);

app.use(router);

const mountApp = async (): Promise<void> => {
  if (import.meta.env.DEV && import.meta.env.VITE_KKM_FAKE === 'true') {
    try {
      const { installKkmFakeBridge } = await import('@/app/dev/kkm-fake-bridge');
      installKkmFakeBridge();
    } catch (error) {
      console.warn('[KkmFakeBridge.initialization_failed]', {
        technicalErrorType: error instanceof Error ? error.name : typeof error,
      });
    }
  }

  app.mount('#app');
};

void mountApp();

const initializeErrorTelemetry = async (): Promise<void> => {
  try {
    const { initializeErrorTelemetryProvider } = await import('@/app/providers/error-telemetry-provider');
    initializeErrorTelemetryProvider();
  } catch {
    console.warn('[telemetry] Не удалось инициализировать сбор ошибок');
  }
};

if (import.meta.env.PROD) {
  void initializeErrorTelemetry();
}

export { app };
